import * as modelsGet from "../models/get";
import { getMorticians } from "../api/persons";

var morticians: modelsGet.IPerson[];

/**
 * Gibt alle Bestatter zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getMorticiansAsync(reload: boolean = false): Promise<modelsGet.IPerson[]>
{
    if (morticians == null || reload)
    {
        morticians = await getMorticians();
    }

    return morticians;
}